
import React from 'react';
import { Button } from "@/components/ui/button";
import { ExternalLink, LogOut, Eye, EyeOff, Lock } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import LoginDialog from './LoginDialog';

interface UserControlsProps {
  isMedsPage: boolean;
  isLoginOpen: boolean;
  setIsLoginOpen: (open: boolean) => void;
}

const UserControls: React.FC<UserControlsProps> = ({ 
  isMedsPage, 
  isLoginOpen, 
  setIsLoginOpen 
}) => {
  const { isAuthenticated, logout, toggleProviderView, isProviderView } = useAuth();

  return (
    <div className="flex items-center gap-2">
      {/* Show controls in navbar only when NOT on medications page */}
      {isAuthenticated && !isMedsPage && (
        <>
          <Button 
            variant="outline" 
            size="sm" 
            className="hidden sm:flex items-center" 
            onClick={toggleProviderView}
          >
            {isProviderView ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
            Clinical
          </Button>
          
          <Button 
            variant="ghost" 
            size="icon" 
            className="hidden sm:flex items-center text-muted-foreground h-9 w-9" 
            onClick={logout}
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </>
      )}
      
      {!isAuthenticated && (
        <LoginDialog 
          isOpen={isLoginOpen} 
          onOpenChange={setIsLoginOpen} 
        />
      )}
      
      <Button 
        variant="secondary" 
        className="hidden sm:flex items-center hover:bg-secondary/90 font-medium" 
        size="sm"
        onClick={() => window.open('https://link.trimfit.tech/widget/form/mJSjpTm4gmTrZFDQQU1p', '_blank')}
      >
        Speak with a Provider <ExternalLink className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};

export default UserControls;
